export default __webpack_public_path__ + "1c15fdf1441189ad7956ca7670d39d4b.svg";